/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import { Input, Col, Button, Card, CardBody, CardHeader, Container, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Spring } from 'react-spring'
import { TimingAnimation, Easing } from 'react-spring/dist/addons'

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/

import ApiCalls from "../custom-classes/api-calls";
import LanguageManager from '../custom-classes/language-manager';
import FormGroupAddress from './forms/form-group-address';
import FormGroupNewPassword from './forms/form-group-new-password';
import NavbarMobile from './navbar/navbar-mobile';

// This is the item list
class UpdateInformation extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });
        this.props.addTranslation(global);

        this.state = {
            oldPassword: '',
            password: '',
            passwordRetype: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            validAddress: true,
            validCity: true,
            validState: true,
            validCountry: true,
            validZipCode: true,
            proceedSubmitAddress: true,
            proceedSubmitPassword: false,
            showModalTerms: false,
            showModalChildrensPolicy: false,
            checkPolicyAccepted: false,
            checkChildPolicyAccepted: false,
            modalMessage: '',
            modal: false,
        };

        this.saveOldPasswordState = this.saveOldPasswordState.bind(this);
        this.saveNewPassword = this.saveNewPassword.bind(this);
        this.updateUserMainAddress = this.updateUserMainAddress.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    /** Handles the API response
     *
     */
    componentDidMount(){
        let apiCall = ApiCalls.getUserMainAddress();
        apiCall.then((data)=> {
            console.log(data);
            this.setState({
                addressLine1: data.UserAddress.AddressLine1,
                addressLine2: '',
                city:  data.UserAddress.City,
                state: data.UserAddress.State,
                country: data.UserAddress.CountryIsoCode2, // Default
                zipCode: data.UserAddress.Zip
            });
        });
    }

    /**
     * Hide or shows the message window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    /**
     * Saves the old password in the state
     * @param event
     */
    saveOldPasswordState(event){
            this.setState({oldPassword: event.target.value}, () =>{
                this.setSubmitNewPasswordState();
            });
    };

    /**
     * Saves the password state
     * @param field
     */
    savePasswordState = (field) =>(newValue)=>{
        this.setState(
            {
                'password': newValue.password,
                'passwordRetype': newValue.passwordRetype
            },() =>{
                this.setSubmitNewPasswordState();
            });
    };

    /** Save the address **/
    saveAddress = (field) => (newValue) =>{
        this.setState(
            {
                'addressLine1': newValue.addressLine1,
                'addressLine2': newValue.addressLine2,
                'city': newValue.city,
                'country': newValue.country,
                'state': newValue.state,
                'zipCode': newValue.zipCode,
                'validAddress': newValue.validAddress,
                'validCity': newValue.validCity,
                'validCountry': newValue.validCountry,
                'validPhone': newValue.validPhone,
                'validState': newValue.validState,
                'validZipCode': newValue.validZipCode
            },() =>{
                this.setSubmitAddressButtonState();
            });
    };

    /**
     * Set the state of the button to submit the address
     */
    setSubmitNewPasswordState(){
            this.setState({proceedSubmitPassword:(
                this.state.oldPassword.length > 5
                && this.state.password.length > 5
                && this.state.passwordRetype.length > 5
            )});
    }

    /**
     * Saves the new password in the api call
     */
    saveNewPassword(){

        // Saves the new password
        let apiCall = ApiCalls.insertNewPassword(this.state.oldPassword, this.state.password, this.state.passwordRetype);
        apiCall.then((data)=> {
            this.setState({modalMessage: data.Messages[0]});
            this.toggle();

        });
    }

    /**
     * Send to the service the new address
     */
    updateUserMainAddress(){

        // Saves the new password
        let apiCall = ApiCalls.updateUserMainAddress(this.state.addressLine1, this.state.addressLine2, this.state.city, this.state.state,
            this.state.country, this.state.country, this.state.zipCode);
        apiCall.then((data)=> {
            this.setState({modalMessage: data.Messages[0]});
            this.toggle();

        });
    }

    /** Sets the submit address button state **/
    setSubmitAddressButtonState(){
        this.setState({proceedSubmitAddress:(
            this.state.validAddress
            && this.state.validCity
            && this.state.validCountry
            && this.state.validState
            && this.state.validZipCode
        )});
    }

    // Call the item list
    render() {
        return(
            <div>
                <NavbarMobile/>
                <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation} config={{duration:450, easing: Easing.linear}}>
                    {
                        styles =>
                            <Container>
                                <Row>
                                <Col sm={{size: 12, offset: 0}} md={{size:6}} lg={{size:6}} style={styles}>
                                    <Card className="card-white">
                                        <CardHeader className="card-cyan">
                                            <h4 className="white-text">
                                                <Translate id="form-updates.edit-your-info" options={{renderInnerHtml: true}}/>
                                            </h4>
                                            <small>
                                                <Translate id="form-updates.edit-info-subtitle" options={{renderInnerHtml: true}}/>
                                            </small>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col sm={{size: 12, offset: 0}} lg={{size:12, offset: 0}} md={{size:12, offset: 0}}>
                                                    <FormGroupAddress data={this.state} updateParent={this.saveAddress()}/>
                                                </Col>
                                                <Col sm={{size: 10, offset: 1}} lg={{size:10, offset: 1}} md={{size:10, offset: 1}}>
                                                    <Button block color="success" disabled={!this.state.proceedSubmitAddress}
                                                            onClick={this.updateUserMainAddress}>
                                                        <Translate id="general.submit" options={{renderInnerHtml: true}}/>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                    <Col sm={{size: 12, offset: 0}}  md={{size:6}} lg={{size:6}} style={styles}>
                                        <Card className="card-white">
                                            <CardHeader className="card-cyan">
                                                <h4 className="white-text">
                                                    <Translate id="form-updates.reset-your-password-title" options={{renderInnerHtml: true}}/>
                                                </h4>
                                                <small>
                                                    <Translate id="form-updates.reset-your-password-subtitle" options={{renderInnerHtml: true}}/>
                                                </small>
                                            </CardHeader>
                                            <CardBody>
                                                <Row>
                                                    <Col sm={{size: 10, offset: 1}} lg={{size:10, offset: 1}} md={{size:10, offset: 1}}>
                                                        <p>
                                                            <Translate id="form-updates.old-password-instructions" options={{renderInnerHtml: true}}/>
                                                        </p>
                                                        <Input type="password" onChange={this.saveOldPasswordState}/>
                                                    </Col>
                                                </Row>
                                                <Row>

                                                    <Col sm={{size: 12, offset: 0}} lg={{size:12, offset: 0}} md={{size:12, offset: 0}}>
                                                        <FormGroupNewPassword data={this.state} updateParent={this.savePasswordState()}/>
                                                    </Col>
                                                    <Col sm={{size: 10, offset: 1}} lg={{size:10, offset: 1}} md={{size:10, offset: 1}}>
                                                        <Button block color="success" disabled={!this.state.proceedSubmitPassword}
                                                                onClick={this.saveNewPassword}>
                                                            <Translate id="general.submit"/>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>

                                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                                    <ModalHeader className="card-orange" toggle={this.toggle}>
                                        <Translate id="form-updates.attention" options={{renderInnerHtml: false}}/>
                                    </ModalHeader>
                                    <ModalBody className="card-white">
                                        <p>{this.state.modalMessage}</p>
                                    </ModalBody>
                                    <ModalFooter className="card-white">
                                        <Button onClick={this.toggle} color="info">
                                            <Translate id="subscriptions.close" options={{renderInnerHtml: false}}/>
                                        </Button>
                                    </ModalFooter>
                                </Modal>

                            </Container>
                    }
                </Spring>
            </div>
        )
    };
}

export default withLocalize(UpdateInformation);


// WEBPACK FOOTER //
// ./src/components/update-information.js